import requestStatuses from './request-statuses';

export default {
  createStatus: requestStatuses.NULL,
  readStatus: requestStatuses.NULL,
  updateStatus: requestStatuses.NULL,
  deleteStatus: requestStatuses.NULL
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-resource/es/utils/initial-resource-meta-state.js
// module id = 291
// module chunks = 2